<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Precios por Proveedor</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <ProveedoresSelectComponent
                :current="current"
              ></ProveedoresSelectComponent>
              <small
                v-if="current.errors && current.errors.proveedor"
                class="form-text text-danger"
                >{{ current.errors.proveedor[0] }}</small
              >
            </div>
          </div>
        </div>
        <div v-if="current.proveedor" class="dropdown">
          <button
            class="btn btn-info dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
          >
            <i class="fas fa-download"></i>
            Generar Reporte
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" @click="ImprimirXls(current)" ><i class="far fa-file-alt"></i> - XLS</a>
            <a class="dropdown-item" @click="ImprimirPdf(current)" ><i class="far fa-file-alt"></i> - PDF</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
export default {
  components: {
    ProveedoresSelectComponent,
  },
  data() {
    return {
      current: {
        proveedor: "",
      },
      data: [],
    };
  },
  mounted() {},
  methods: {
    ImprimirPdf(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_name=catalogos/PreciosPorProveedor.jrxml&proveedorid=${current.proveedor.codigo}`
      );
      current.proveedor = "";
    },
    ImprimirXls(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=xls&report_name=catalogos/PreciosPorProveedor.jrxml&proveedorid=${current.proveedor.codigo}`
      );
      current.proveedor = "";
    },
  },
};
</script>
